function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ActionButton, StepLayout } from "../../BusinessOnboardingWidget.utils";
import styles from "../CompleteKYC/CompleteKYC.module.scss";
import { CompleteKYCIcon } from "../../BusinessOnboardingWidget.icons";
import { openInNewTabProps } from "../../../../../constants";
const VerifyYourIdentity = props => {
  const {
    kycStepComplete,
    connectBankAccountStepComplete
  } = props.extraProps;
  const baseTestId = 'onboarding-widget-verifyYourIdentity';
  const disabled = !kycStepComplete || !connectBankAccountStepComplete;
  const title = props.isComplete ? "You've successfully activated your account" : 'Verify your identity to activate your account';
  const subtitle = props.isComplete ? 'You can now process payments through Anchor.' : 'Identity verification is required to process payments through Anchor. Schedule a quick 5-minute video call below and have your picture ID ready.';
  return /*#__PURE__*/React.createElement(StepLayout, {
    id: "verifyYourIdentity",
    title: /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(baseTestId).concat(props.isComplete ? '-complete' : '', "-title")
    }, title),
    subtitle: subtitle,
    actions: props.isComplete ? null : /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(baseTestId, "-actions"),
      className: styles.actionsWrapper
    }, /*#__PURE__*/React.createElement(ActionButton, _extends({
      as: "a",
      href: "https://book.avoma.com/anchor/enable-payments/"
    }, openInNewTabProps, {
      tooltip: disabled ? {
        title: /*#__PURE__*/React.createElement("div", {
          "data-testid": "".concat(baseTestId, "-disabled-tooltip")
        }, "To verify your identity, ensure your bank account is connected and your business verification is complete.")
      } : undefined,
      "data-testid": "".concat(baseTestId).concat(disabled ? '-disabled' : '', "-button"),
      disabled: disabled
    }), "Verify identity")),
    icon: /*#__PURE__*/React.createElement(CompleteKYCIcon, null)
  });
};
export default VerifyYourIdentity;